const simpleAnalytics = {
    id: 'G-C2Z0E7H0E6',
    enabled: false,

    setup() {
        // Load Google Analytics script
        const script = document.createElement('script');
        script.async = true;
        script.src = `https://www.googletagmanager.com/gtag/js?id=${this.id}`;
        document.head.appendChild(script);

        window.dataLayer = window.dataLayer || [];
        window.gtag = function () { window.dataLayer.push(arguments); };
        window.gtag('js', new Date());
        window.gtag('config', this.id);

        this.enabled = true;
        console.log('Google Analytics initialized');
    },

    enable(consent = true) {
        if (consent) {
            this.setup();
            localStorage.setItem('analytics_consent', 'true');
        }
    },

    trackPage(route, title, screenClass) {
        if (!this.enabled || !window.gtag) return;

        const params = {
            page_path: route,
            page_title: title || document.title
        };

        if (screenClass) {
            params.screen_class = screenClass;
        }

        window.gtag('config', this.id, params);
        console.log(`Tracked page: ${title || route}`);
    },

    trackEvent(category, action, label) {
        if (!this.enabled || !window.gtag) return;

        window.gtag('event', action, {
            event_category: category,
            event_label: label
        });

        console.log(`Tracked event: ${category} - ${action} - ${label}`);
    }
};

export default simpleAnalytics;